import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { useParams } from "react-router-dom";
import { useUser } from './Context/UserContext';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import "../styles/CreateInvoice.css";
import profileImg from '../assets/logo.png';
import DashboardLayout from "./DashboardLayout";
const AdminAccessControl = () => {
    // State for the Form Fields
    const [formData, setFormData] = useState({
        userType: "",
        departmentName: "",
        userName: "",
        empId: "",
        emailId: "",
        isActive: "",
   
    });

    const [records, setRecords] = useState([]);
    // Dropdown Options Mock Data (Replace with API calls in useEffect if needed)
    const [userTypesList, setUserTypesList] = useState([]);
    const [userNamesList, setUserNamesList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [editingRowId, setEditingRowId] = useState(null);
    const [errors, setErrors] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 7;

    const indexOfLast = currentPage * rowsPerPage;
    const indexOfFirst = indexOfLast - rowsPerPage;

    const filteredRecords = records.filter((row) =>
        row.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.emailId.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const currentRecords = filteredRecords.slice(indexOfFirst, indexOfLast);

    const totalPages = Math.ceil(filteredRecords.length / rowsPerPage);
    const [editRowData, setEditRowData] = useState({
        userName: "",
        emailId: "",
        isActive: ""
    });



    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Clear error for the field being edited
        setErrors((prev) => ({
            ...prev,
            [name]: ""
        }));
    };

    const handleEdit = (row) => {
        console.log("Clicked Row:", row);
        console.log("Row ID:", row.id);

        setEditingRowId(row.id);

        setEditRowData({
            userName: row.userName,
            emailId: row.emailId,
            isActive: row.isActive
        });
    };

    const handleRowChange = (e, field) => {
        const value = e.target.value;

        setEditRowData(prev => ({
            ...prev,
            [field]: value
        }));
    }; 

    const handleSave = async (id) => {
        try {
            const payload = {
                userName: editRowData.userName,
                emailId: editRowData.emailId,
                isActive: editRowData.isActive
            };

            await axios.put(
                `/api/adminaccess/updateuser/${id}`,
                payload
            );

            alert("Updated successfully");

            setEditingRowId(null);
            fetchUsers();

        } catch (err) {
            console.log(err);
            alert("Update failed");
        }
    };
    
    useEffect(() => {
        const fetchUserTypes = async () => {
            try {
                const res = await axios.get(
                    "/api/adminaccess/usertypes"
                );
                setUserTypesList(res.data);
            } catch (err) {
                console.log("UserTypes Error:", err);
            }
        };

        fetchUserTypes();
    }, []);

    useEffect(() => {
        const fetchUserNames = async () => {
            try {
                const res = await axios.get(
                    "/api/adminaccess/usernames"
                );

                setUserNamesList(res.data);
            } catch (err) {
                console.log(" usernames Error:", err);
            }
        };

        fetchUserNames();
    }, []);


    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const res = await axios.get(
                "/api/adminaccess/users"
            );

            console.log("FETCH USERS:", res.data);

            setRecords(res.data);
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        console.log("RECORDS STATE:", records);
    }, [records]);

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const res = await axios.get(
                    "/api/adminaccess/departments"
                );
                setDepartmentList(res.data);
            } catch (err) {
                console.log("Department Error:", err);
            }
        };

        fetchDepartments();
    }, []);

    const handleSaveUser = async () => {

        let newErrors = {};

        // Required validations
        if (!formData.userType)
            newErrors.userType = "Please select User Type";

        if (!formData.departmentName)
            newErrors.departmentName = "Please select Department Name";

        if (!formData.userName.trim())
            newErrors.userName = "Please enter User Name";

        if (!formData.empId.trim())
            newErrors.empId = "Please enter Employee ID";

        if (!formData.emailId.trim()) {
            newErrors.emailId = "Please enter Email ID";
        }
        else {
            // Email format validation
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailPattern.test(formData.emailId)) {
                newErrors.emailId = "Please enter a valid Email ID (example@company.com)";
            }
        }

        setErrors(newErrors);

        // Stop save if validation fails
        if (Object.keys(newErrors).length > 0)
            return;

        try {

            const payload = {
                userTypeId: formData.userType,
                userName: formData.userName,
                empId: formData.empId,
                emailId: formData.emailId,
                isActive: "TRUE",
                deptId: formData.departmentName
            };

            const res = await axios.post(
                "/api/adminaccess/createuser",
                payload
            );

            alert("User Created Successfully");

            // Clear form after successful save
            setFormData({
                userType: "",
                departmentName: "",
                userName: "",
                empId: "",
                emailId: "",
                isActive: ""
            });

            setErrors({});

            fetchUsers();

        } catch (err) {
            console.log(err);
            alert("Failed to save user");
        }
    };
    const handleClear = () => {
        setFormData({
            userType: "",
            departmentName: "",
            userName: "",
            empId: "",
            emailId: "",
            isActive: ""
        });
    };



    return (
        <DashboardLayout>
            <Container
                fluid
                className="px-4 py-4"
                style={{
                    minHeight: "40vh",
                    background: "var(--bs-tertiary-bg)"
                }}
            >

                <Container
                    fluid
                    className="px-4 py-3"
                    style={{
                        background: "var(--bs-tertiary-bg)",
                        minHeight: "50vh"
                    }}
                >

                    {/* TITLE */}
                    <div
                        style={{
                            background: "linear-gradient(90deg,#0d6efd,#6610f2)",
                            borderRadius: "10px",
                            padding: "12px",
                            marginBottom: "10px",
                            boxShadow: "0 6px 15px rgba(0,0,0,.15)"
                        }}
                    >
                        <h3
                            className="text-center mb-0"
                            style={{
                                color: "#fff",
                                fontWeight: "700"
                            }}
                        >
                            Super Admin (User) Screen
                        </h3>
                    </div>

                    <form onSubmit={(e) => e.preventDefault()}>

                        <div className="d-flex justify-content-center">

                            <div
                                style={{
                                    width: "900px",
                                    background: "var(--bs-body-bg)",
                                    color: "var(--bs-body-color)",
                                    border: "1px solid var(--bs-border-color)",
                                    borderRadius: "15px",
                                    padding: "10px",
                                    boxShadow: "0 8px 20px rgba(0,0,0,.12)"
                                }}
                            >

                                {/* ROW 1 */}

                                <div className="row">

                                    {/* USER TYPE */}

                                    <div className="col-md-6 mb-3">

                                        <label
                                            style={{
                                                fontWeight: "600",
                                                color: "#0d6efd",
                                                marginBottom: "5px"
                                            }}
                                        >
                                            User Type
                                        </label>

                                        <select
                                            name="userType"
                                            value={formData.userType}
                                            onChange={handleChange}
                                            className="form-select form-select-sm"
                                            style={{
                                                border: "2px solid #0d6efd",
                                                borderRadius: "8px"
                                            }}
                                        >
                                            <option value="">Select User Type</option>
                                            <option value="1">Verifier</option>
                                            <option value="2">Department Head</option>
                                        </select>

                                        {errors.userType && (
                                            <small style={{ color: "red" }}>
                                                {errors.userType}
                                            </small>
                                        )}

                                    </div>

                                    {/* DEPARTMENT */}

                                    <div className="col-md-6 mb-3">

                                        <label
                                            style={{
                                                fontWeight: "600",
                                                color: "#198754",
                                                marginBottom: "5px"
                                            }}
                                        >
                                            Department Name
                                        </label>

                                        <select
                                            name="departmentName"
                                            value={formData.departmentName}
                                            onChange={handleChange}
                                            className="form-select form-select-sm"
                                            style={{
                                                border: "2px solid #198754",
                                                borderRadius: "8px"
                                            }}
                                        >
                                            <option value="">Select Department</option>

                                            {userTypesList.map((item) => (
                                                <option
                                                    key={item.p_id}
                                                    value={item.p_id}
                                                >
                                                    {item.p_userType}
                                                </option>
                                            ))}

                                        </select>

                                        {errors.departmentName && (
                                            <small style={{ color: "red" }}>
                                                {errors.departmentName}
                                            </small>
                                        )}

                                    </div>

                                </div>

                                {/* ROW 2 */}

                                <div className="row">

                                    {/* USER NAME */}

                                    <div className="col-md-6 mb-3">

                                        <label
                                            style={{
                                                fontWeight: "600",
                                                color: "#fd7e14",
                                                marginBottom: "5px"
                                            }}
                                        >
                                            User Name
                                        </label>

                                        <input
                                            type="text"
                                            name="userName"
                                            value={formData.userName}
                                            onChange={handleChange}
                                            className="form-control form-control-sm"
                                            style={{
                                                border: "2px solid #fd7e14",
                                                borderRadius: "8px"
                                            }}
                                        />

                                        {errors.userName && (
                                            <small style={{ color: "red" }}>
                                                {errors.userName}
                                            </small>
                                        )}

                                    </div>

                                    {/* EMP ID */}

                                    <div className="col-md-6 mb-3">

                                        <label
                                            style={{
                                                fontWeight: "600",
                                                color: "#dc3545",
                                                marginBottom: "5px"
                                            }}
                                        >
                                            Employee ID
                                        </label>

                                        <input
                                            type="text"
                                            name="empId"
                                            value={formData.empId}
                                            onChange={handleChange}
                                            className="form-control form-control-sm"
                                            style={{
                                                border: "2px solid #dc3545",
                                                borderRadius: "8px"
                                            }}
                                        />

                                        {errors.empId && (
                                            <small style={{ color: "red" }}>
                                                {errors.empId}
                                            </small>
                                        )}

                                    </div>

                                </div>

                                {/* ROW 3 */}

                                <div className="row align-items-end">

                                    {/* EMAIL */}

                                    <div className="col-md-6 mb-3">

                                        <label
                                            style={{
                                                fontWeight: "600",
                                                color: "#6f42c1",
                                                marginBottom: "5px"
                                            }}
                                        >
                                            Email ID
                                        </label>

                                        <input
                                            type="email"
                                            name="emailId"
                                            value={formData.emailId}
                                            onChange={handleChange}
                                            className="form-control form-control-sm"
                                            style={{
                                                border: "2px solid #6f42c1",
                                                borderRadius: "8px"
                                            }}
                                        />

                                        {errors.emailId && (
                                            <small style={{ color: "red" }}>
                                                {errors.emailId}
                                            </small>
                                        )}

                                    </div>

                                    {/* BUTTONS */}

                                    <div
                                        className="col-md-6 mb-3 text-end"
                                    >

                                        <button
                                            type="button"
                                            onClick={handleSaveUser}
                                            style={{
                                                background:
                                                    "linear-gradient(90deg,#198754,#20c997)",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "8px",
                                                padding: "8px 25px",
                                                fontWeight: "600",
                                                marginRight: "10px",
                                                boxShadow:
                                                    "0 5px 10px rgba(0,0,0,.2)"
                                            }}
                                        >
                                            💾 Save
                                        </button>

                                        <button
                                            type="button"
                                            onClick={handleClear}
                                            style={{
                                                background:
                                                    "linear-gradient(90deg,#dc3545,#fd7e14)",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "8px",
                                                padding: "8px 25px",
                                                fontWeight: "600",
                                                boxShadow:
                                                    "0 5px 10px rgba(0,0,0,.2)"
                                            }}
                                        >
                                            ✖ Clear
                                        </button>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </form>

                </Container>


                {/* Search Bar + Pagination */}
                <div
                    className="d-flex justify-content-between align-items-center mb-3"
                    style={{ width: "100%" }}
                >

                    {/* Search Bar - Left */}
                    <div
                        style={{
                            width: "320px"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                background: "var(--bs-body-bg)",
                                border: "2px solid #6f42c1",
                                borderRadius: "25px",
                                padding: "4px 12px",
                                boxShadow: "0 4px 10px rgba(111,66,193,0.15)"
                            }}
                        >
                            <span
                                style={{
                                    fontSize: "16px",
                                    color: "#6f42c1",
                                    marginRight: "8px"
                                }}
                            >
                                🔍
                            </span>

                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Search by Email ID or Username"
                                className="form-control"
                                style={{
                                    border: "none",
                                    boxShadow: "none",
                                    fontSize: "12px",
                                    padding: "4px",
                                    background: "transparent",
                                    color: "var(--bs-body-color)"
                                }}
                            />
                        </div>
                    </div>

                    {/* Page Controls - Right */}
                    <div>
                        <div style={{ flexShrink: 0 }}>
                        <div className="pagination-group">

                            <button
                                className="page-btn"
                                onClick={() => setCurrentPage(1)}
                                disabled={currentPage === 1}
                                title="First Page"
                            >
                                «
                            </button>

                            <button
                                className="page-btn"
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                                title="Previous Page"
                            >
                                ‹
                            </button>

                            <span className="page-indicator">
                                {currentPage} / {totalPages || 1}
                            </span>

                            <button
                                className="page-btn"
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                                title="Next Page"
                            >
                                ›
                            </button>

                            <button
                                className="page-btn"
                                onClick={() => setCurrentPage(totalPages)}
                                disabled={currentPage === totalPages}
                                title="Last Page"
                            >
                                »
                            </button>

                            </div>
                        </div>
                    </div>

                </div>
               
                {/* Records Data Table */}
                <div
                    
                    style={{
                        background: "var(--bs-tertiary-bg)",
                        border: "1px solid var(--bs-border-color)"
                    }}
                >
                    <table className="table align-middle text-center">
                        <thead>
                            <tr
                                style={{
                                    background: "linear-gradient(90deg, #198754, #20c997)",
                                    color: "#fff",
                                    fontSize: "15px",
                                    fontWeight: "600"
                                }}
                            >
                                <th className="py-3">USER TYPE</th>
                                <th className="py-3">USER ID</th>
                                <th className="py-3">USER NAME</th>
                                <th className="py-3">EMAIL ID</th>
                                <th className="py-3">ACTIVE STATUS</th>
                                <th className="py-3">ACTION</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentRecords.map((row) => {
                                const rowKey = row.id;

                                return (
                                    <tr
                                        key={rowKey}
                                        style={{
                                            backgroundColor:
                                                editingRowId === rowKey
                                                    ? "#fff8e1"
                                                    : "var(--bs-body-bg)",
                                            transition: "0.3s"
                                        }}
                                    >
                                        {/* USER TYPE */}
                                        
                                        <td>
                                            <span
                                                style={{
                                                    fontWeight: "600",
                                                    color: "var(--bs-body-color)"
                                                }}
                                            >
                                                {row.userType}
                                            </span>
                                        </td>

                                        {/* USER ID */}
                                        <td>
                                            <span
                                                style={{
                                                    fontWeight: "600",
                                                    color: "#6f42c1"
                                                }}
                                            >
                                                {row.userId}
                                            </span>
                                        </td>

                                        {/* USER NAME */}
                                        <td>
                                            {editingRowId === rowKey ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={editRowData.userName}
                                                    onChange={(e) =>
                                                        handleRowChange(e, "userName")
                                                    }
                                                />
                                            ) : (
                                                <span
                                                    style={{
                                                        fontWeight: "600",
                                                            color: "var(--bs-body-color)"
                                                    }}
                                                >
                                                    {row.userName}
                                                </span>
                                            )}
                                        </td>

                                        {/* EMAIL */}
                                        <td>
                                            {editingRowId === rowKey ? (
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    value={editRowData.emailId}
                                                    onChange={(e) =>
                                                        handleRowChange(e, "emailId")
                                                    }
                                                />
                                            ) : (
                                                <span style={{ color: "#0d6efd" }}>
                                                    {row.emailId}
                                                </span>
                                            )}
                                        </td>

                                        {/* IS ACTIVE */}
                                        <td>
                                            {editingRowId === rowKey ? (
                                                <select
                                                    className="form-select"
                                                    value={editRowData.isActive}
                                                    onChange={(e) =>
                                                        handleRowChange(e, "isActive")
                                                    }
                                                >
                                                    <option value="TRUE">Active</option>
                                                    <option value="FALSE">Inactive</option>
                                                </select>
                                            ) : (
                                                <span
                                                    className={`badge ${row.isActive === "TRUE"
                                                        ? "bg-success"
                                                        : "bg-danger"
                                                        }`}
                                                    style={{
                                                        fontSize: "13px",
                                                        padding: "8px 14px"
                                                    }}
                                                >
                                                    {row.isActive === "TRUE" ? "Active" : "Inactive"}
                                                </span>
                                            )}
                                        </td>

                                        {/* ACTION BUTTON */}
                                        <td className="text-center">
                                            {editingRowId === rowKey ? (
                                                <button
                                                    type="button"
                                                    className="action-btn save"
                                                    onClick={() => handleSave(row.id)}
                                                >
                                                    💾 SAVE
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="action-btn edit"
                                                    onClick={() => handleEdit(row)}
                                                >
                                                    ✏️ EDIT
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                


            </Container>
        </DashboardLayout>
    );
};

export default AdminAccessControl;